<template>
    <div class="wrapper autoshow">
        <div class="auto_img">
            <img :src="template.head_m" alt="头图">
        </div>
<!--        head_img end-->
        <div class="sign_form" :style="`backgroundColor: ${template.middle_m}`">
            <ul class="count_time" v-if="template.is_count">
                <li>车展倒计时：</li>
                <li><span>{{count_day}}</span>天</li>
                <li><span>{{count_hour}}</span>时</li>
                <li><span>{{count_minute}}</span>分</li>
                <li><span>{{count_second}}</span>秒</li>
            </ul>
            <!--        count_time end-->
            <el-form
                    :model="action_form"
                    :rules="rules"
                    ref="action_form"
                    hide-required-asterisk
            >
                <el-form-item label="选择您的意向车型">
                    <div class="search_cars" @click="clk_brand()" :class="{is_black:is_carchecked}">
                        {{ checkedBrand }}
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </el-form-item>

                <el-form-item prop="name" label="怎么称呼您">
                    <el-input
                            v-model="action_form.name"
                            placeholder="请输入姓名"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="phone" label="您的手机号(已加密)">
                    <el-input
                            v-model="action_form.phone"
                            placeholder="请输入电话"
                            type="number"
                    ></el-input>
                </el-form-item>

                <el-form-item prop="city" label="请选择城市" class="margin_cus" v-if="is_city" :class="template.middle_m == '#FFFFFF' ? 'label_color' : ''">
                    <el-cascader
                            placeholder="快速选择城市"
                            :options="citys"
                            :props="cascaderProps"
                            v-model="action_form.city"
                            ref="bind_city_ref"
                            style="width: 100%"
                    ></el-cascader>
                </el-form-item>
                <!--                隐私声明-->
                <policy></policy>

                <el-form-item class="form_btn">
                    <el-button @click="submitForm('action_form')" :disabled="is_overdue" :class="{opacity: is_overdue}"
                               :style="`backgroundColor: ${template.button_bg_color}; color:${template.button_font_color};`"
                    >
                        <span v-if="is_overdue">活动已结束</span>
                        <span v-else>{{template.button_title}}</span>
                    </el-button
                    >
                </el-form-item>
            </el-form>

            <registered v-if="template.is_banner == 1"></registered>
        </div>
<!--        sign_form end-->

        <div class="auto_img">
            <img :src="template.tail_m" alt="详情图">
        </div>
<!--        info_img end-->

<!--        <div class="back_top" @click="toTop" :class="{is_btm_btn: is_display}">-->
<!--            <span>{{ template.bottom_button_title }}</span>-->
<!--        </div>-->

        <div class="back_top" @click="toTop" :class="{is_btm_btn: is_display}">
            <span>{{ template.bottom_button_title }}</span>
        </div>

        <copyright v-if="template.is_copyright == 1"></copyright>

        <el-dialog :visible.sync="dialogVisible" v-if="dialogVisible" class="brand_dialog">
            <div v-if="isShow" class="brand_wrap">
                <div class="letters">
                    <ul>
                        <li
                                v-for="(list, letter) in car_list"
                                :key="letter"
                                @click="toLetter(letter)"
                                :class="isactive == letter ? 'cur' : ''"
                        >
                            {{ letter }}
                        </li>
                    </ul>
                </div>
                <!-- letters end -->
                <div class="carslist">
                    <template v-for="(brands, letter) in car_list">
                        <div :key="letter">
                            <div class="character" :id="'letter_' + letter">
                                {{ letter }}
                            </div>
                            <ul class="car_tree">
                                <li
                                        v-for="brand in brands"
                                        :key="brand.id"
                                        @click="toCarlist(brand)"
                                >
                                    <img :src="brand.logo" alt="" />
                                    <span>{{ brand.name }}</span>
                                </li>
                            </ul>
                        </div>
                    </template>
                </div>
            </div>

            <div v-else class="carlist" id="dialog_view">
                <div class="carBack" @click="isShow = true">返回</div>
                <template v-for="(automaker, automaker_id) in car_object.children">
                    <div :key="automaker_id">
                        <h3>{{ automaker.name }}</h3>
                        <ul>
                            <li
                                    v-for="(series, series_id) in automaker.children"
                                    :key="series_id"
                                    @click="checkedCar(car_object.id, automaker_id, series.id, automaker.name, series.name)"
                            >
                                <img :src="'/mini' + series.thumb" alt="series.name" v-if="series.thumb"/>
                                <img src="../../assets/images/brand_default.jpg" alt="暂无图片" v-else>
                                <span>{{ series.name }}</span>
                            </li>
                        </ul>
                    </div>
                </template>
            </div>

            <!-- carslist end -->
        </el-dialog>

<!--        //2022-08-26-->
        <el-dialog :visible.sync="dialogVisible_login" v-if="dialogVisible_login" width="100%" class="login_dialog" @close="close_login_dialog">
            <el-form
                    :model="action_form"
                    :rules="rules"
                    ref="action_form_dialog"
                    hide-required-asterisk
                    class="sign_form"
            >
                <el-form-item label="选择您的意向车型">
                    <div class="search_cars" @click="clk_brand()" :class="{is_black:is_carchecked}">
                        {{ checkedBrand }}
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </el-form-item>

                <el-form-item prop="name" label="怎么称呼您">
                    <el-input
                            v-model="action_form.name"
                            placeholder="请输入姓名"
                    ></el-input>
                </el-form-item>
                <el-form-item prop="phone" label="您的手机号(已加密)">
                    <el-input
                            v-model="action_form.phone"
                            placeholder="请输入电话"
                            type="number"
                    ></el-input>
                </el-form-item>

                <el-form-item prop="city" label="请选择城市" class="margin_cus" v-if="is_city">
                    <el-cascader
                            placeholder="快速选择城市"
                            :options="citys"
                            :props="cascaderProps"
                            v-model="action_form.city"
                            ref="bind_city_ref"
                            filterable
                            style="width: 100%"
                    ></el-cascader>
                </el-form-item>
                <!--                隐私声明-->
                <policy_mode></policy_mode>

                <el-form-item class="form_btn">
                    <el-button @click="submitForm('action_form_dialog')" :disabled="is_overdue" :class="{opacity: is_overdue}">
                        <span v-if="is_overdue">活动已结束</span>
                        <span v-else>{{template.button_title}}</span>
                    </el-button
                    >
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
    import policy from "../../components/policy";
    import policy_mode from "../../components/policy_mode";
    import copyright from "../../components/copyright";
    import registered from "../../components/registered";
    import _geturl from "../../utils/_geturl";
    import lib_activity from "../../libs/lib_activity";
    import _time from "../../utils/_time";
    import _object from "../../utils/_object";
    import _wx from "../../common/_wx";
    import {isPhone} from "../../common/_validate";
    import { Message } from "element-ui";
    import _car from "../../common/_car";
    import _request from "../../common/_request";

    let action_form = {
        brand_id: 0,
        automaker_id: 0,
        series_id: 0,
        name: "",
        phone: "",
        city: 0, //活动地址
    };

    export default {
        name: "autoshow",
        components:{
            policy,
            copyright,
            registered,
            policy_mode,
        },
        data(){
            return{
                activity_id: 0, //活动ID
                tids: '',//模板ID
                channel: 0,//渠道ID
                template: {},//模板信息
                stime: 0,
                etime: 0,
                is_display: true,//底部按钮
                is_city: false,

                //count
                count_day: 0,
                count_hour: 0,
                count_minute: 0,
                count_second: 0,

                //表单
                action_form: action_form,
                rules: {
                    name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
                    phone: [
                        { required: true, message: "请输入电话", trigger: "blur" },
                        { required: true, validator: isPhone, trigger: "blur" },
                    ],
                }, //验证
                is_overdue: false, //活动是否过期或禁用

                //品牌
                dialogVisible: false, //品牌弹框
                isShow: true, //车型弹框
                isactive: false, //获取点击字母
                checkedBrand: "请选择品牌车型",
                brandName: "",//品牌名称
                carName: "",//车型名称
                car_list: [], //品牌数据
                car_object: [], //车型数据
                is_carchecked: false,//是否选择车型

                //监测
                event_list: [],

                //城市联级选择
                citys: [], //城市数据
                cascaderProps: {
                    value: "id", //指定选项的值
                    label: "name", //指定选项标签
                    children: "children", //指定选项的子选项
                    emitPath: false, //该节点数组
                }, //配置项

                //label 颜色
                item_label_color: '',
                //
                dialogVisible_login: false,
            }
        },
        created() {
            this.activity_id = _geturl('activity_id');
            this.tids = _geturl('tids');
            this.channel = _geturl('channel');
            lib_activity.info(this.activity_id, this.tids, this.info);
            lib_activity.selectedCitys(this.activity_id, this.init_city_list)
            lib_activity.monitor(this.activity_id,this.monitor);
            lib_activity.selectedCitys(this.activity_id,this.init_city_list);
            _car.init(this.activity_id);
            this.get_time();
            window.addEventListener('scroll', this.handleScroll, true);
        },
        methods:{
            info(data) {
                document.title = data.theme;
                this.etime = data.etime;
                this.stime = data.stime;
                this.template = data.template
                this.is_city = data.is_city
                if(!this.template.middle_m || this.template.middle_m == '#FFFFFF'){
                   let dom = document.querySelectorAll('.el-form-item__label');
                    for(let i=0;  i<dom.length; i++){
                        dom[i].style.color = '#000';
                    }
                }
                if (!data.state || _time._current() > data.etime) {
                    this.is_overdue = true;
                }

                if(data.hasOwnProperty('wx_share') && _object._length(data.wx_share)){
                    let options = {}
                    options.title = data.theme
                    options.desc = data.share_theme;
                    options.link = window.location.href;
                    options.image = window.location.protocol + '//' + window.location.host + data.template.thumb;

                    _wx.js_api(data.wx_share, _wx.share, options);
                }
            },

            //倒计时
            get_time(){
                let date = Math.floor(Date.now()/1000);
                //时间差
                let count_time = this.stime - date;

                //定义变量 d,h,m,s保存倒计时的时间
                if (count_time >= 0) {
                    this.count_day = Math.floor(count_time / 60 / 60 / 24);
                    this.count_hour = Math.floor(count_time / 60 / 60 % 24);
                    this.count_minute = Math.floor(count_time / 60 % 60);
                    this.count_second = Math.floor(count_time % 60);
                }
                //递归每秒调用countTime方法，显示动态时间效果
                setTimeout(this.get_time, 1000);
            },

            //弹框
            clk_brand() {
                this.car_list = _car.get();
                this.dialogVisible = true;
            },
            //选择品牌
            toCarlist(brand) {
                this.car_object = brand;
                this.isShow = false;
                setTimeout(function () {
                    document.querySelector("#dialog_view").scrollIntoView();
                }, 1);
            },
            //选择车型
            checkedCar(brand_id, automaker_id, series_id, automaker_name, series_name) {
                this.dialogVisible = false;
                this.action_form.brand_id = brand_id;
                this.action_form.automaker_id = automaker_id;
                this.action_form.series_id = series_id;
                this.checkedBrand = automaker_name + " " + series_name;
                this.isShow = true;
                this.is_carchecked = true;
            },
            //字母
            toLetter(index) {
                this.isactive = index;
                document.querySelector("#letter_" + index).scrollIntoView();
            },

            //监测
            monitor(data){
                let _head = document.getElementsByTagName("head")[0];
                if(_object._length(data)){
                    for(let i in data){
                        let script = document.createElement('script');
                        script.append(data[i].base_code);
                        _head.appendChild(script);
                        this.event_list.push(data[i].event_code)
                    }
                }
            },
            //城市
            init_city_list(data) {
                this.citys = data;
            },

            //提交表单
            submitForm(formName) {
                let that = this;
                if (!this.action_form.series_id) {
                    Message.info("请选择品牌车型");
                    return;
                }
                if(this.is_city == 1 && !this.action_form.city){
                    Message.info("请选择城市");
                    return;
                }

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let data = {
                            activity_id: this.activity_id,
                            channel: this.channel,
                            external_url: this.template.hasOwnProperty('id') ? window.location.href + '&ui_id=' + this.template.id : window.location.href + '&ui_id=0',
                            form_name: this.action_form.name,
                            form_mobile: this.action_form.phone,
                            form_brand_id: this.action_form.brand_id,
                            form_automaker_id: this.action_form.automaker_id,
                            form_series_id: this.action_form.series_id,
                            form_city_id: this.action_form.city,
                            form_ui_id: this.template.hasOwnProperty('id') ? this.template.id : 0,
                        };
                        _request._post(data, function (response) {
                            if (response.code !== _request.success) {
                                Message.info(response.info);
                                return;
                            }
                            Message.info(response.info);


                            for(let i in that.event_list){
                                try {
                                    if(that.event_list[i]){
                                        eval(that.event_list[i])
                                    }
                                }catch (e) {}
                            }

                            if(response.data.ticket == 1){
                                // 邮寄门票
                                setTimeout(() => {
                                    that.$router.push({
                                        path: "level_ticket",
                                        query: {
                                            id: response.data.id,
                                            tid: response.data.tid,
                                        },
                                    });
                                    //清空表单
                                    that.$refs[formName].resetFields();
                                }, 2000);
                                return;
                            }
                            that.$router.push({
                                path: "suc",
                            })
                            //清空表单
                            that.$refs[formName].resetFields();
                        });
                    }
                });
            },

            //置顶
            handleScroll: function(){
                let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
                if(scrollHeight >= 1100){
                    this.is_display = false
                }else{
                    this.is_display = true
                }

            },
            toTop(){
                // this.dialogVisible_login = true;
                // this.$refs['action_form'].resetFields();
                document.documentElement.scrollTop = 300 ;
                document.body.scrollTop = 300;
            },
            close_login_dialog(){
                this.$refs['action_form'].resetFields();
            },


        },
    }
</script>

<style scoped lang="less">
@import "../../assets/style/autoshow/autoshow";
@import "../../assets/style/autoshow/components/form";
</style>
<style lang="less">
@import "../../assets/style/autoshow/components/dialog_cars";
.autoshow{
    .sign_form{
        .el-form-item{
            margin-bottom: 12px;
            .el-form-item__label{
                width: 100%;
                text-align: left;
                color: #fff;
                font-size: 15px;
            }
            .el-form-item__content{
                .el-input__inner{
                    line-height: 45px;
                    height: 45px;
                }
            }
        }
        .label_color{
            .el-form-item__label{
                color: #000;
            }
        }
    }
}
//重写表单弹框
.login_dialog{
    top: auto;
    .el-dialog{
        margin: 0 auto;
        .el-dialog__body{
            padding: 10px;
            .sign_form{
                border-top: 1px solid #e7e7e7;
                .el-form-item{
                    margin-bottom: 7px;
                    .el-form-item__label{
                        color: #000;
                        font-size: 15px;
                        font-weight: bold;
                    }
                    .el-form-item__content{
                        .search_cars{
                            height: 43px;
                            line-height: 43px;
                            color: #c0c4cc;
                            font-size: 13px;
                            border: 1px solid #dedede;
                            border-radius: 7px;
                            padding: 0 15px;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            background-color: #fff;
                        }
                    }
                }
                .form_btn{
                    width: 100%;
                    button{
                        margin-bottom: 0 !important;
                        width: 100%;
                        height: 51px;
                        line-height: 51px;
                        padding: 0;
                        color: #fff;
                        background-color: #ff0024;
                        border: 0;
                        border-radius: 22px;
                        font-weight: 700;
                        font-size: 15px;
                    }
                }

            }

        }
    }
}

/*解决下拉框ios点击两次    */
.el-scrollbar {
    　　.el-scrollbar__bar{
        opacity: 1 !important;
    }
}
</style>
